import React,{Component} from 'react';
import Particles from 'react-particles-js';
import Navigation from './components/Navigation/Navigation';
import AdSense from 'react-adsense';
import {Route,Switch,Redirect} from 'react-router-dom'
import {firestore,getCurrentUser} from './firebase/firebase.utils'
import './App.css';
import SignUp from './pages/signup.component';
import Home from './pages/home.component';
import AdminPage from './pages/admin.component';
import SignIn from './pages/signin.component';
import Footer from './components/footer/footer.component'
import Requests from './pages/requests.component';
import Redeem from './pages/redeempoints';
const particlesOptions = {
  particles: {
    number: {
      value: 31,
      density: {
        enable: true,
        value_area: 800
      }
    }
  },
  style:{
           width: '100%',
           backgroundImage: `url(1.png)` 
        }
}
class App extends Component {
  constructor(){
    super();
    this.state = {user:null};
  }
  unsubscriberFromAuth = null
  async componentDidMount(){
    const that = this
    const s = await getCurrentUser();
    // firestore.collection("users").get().then(docs => {
    //   docs.forEach(element => {
    //     var washingtonRef = firestore.collection("users").doc(element.id);

    //     // Set the "capital" field of the city 'DC'
    //     return washingtonRef.update({
    //         sentRequests : [],
    //         receivedRequests: []
    //     })
    //     .then(() => {
    //         console.log("Document successfully updated!");
    //     })
    //     .catch((error) => {
    //         // The document probably doesn't exist.
    //         console.error("Error updating document: ", error);
    //     });
    //   });
    // })
    // .catch((error)=> {
    //   console.log(error);
    // })
    if(s){
    firestore.collection("users").where("email", "==", s.email)
    .get()
    .then(function(docs) {
      docs.forEach(doc=>{
        // console.log(doc.data());
        that.loadUser(doc.data())
      })
    })
    .catch(function(error) {
        console.log("Error getting documents: ", error);
    });
  }
  }

  loadUser = (data) => {
    this.setState({user: {
      id: data.id,
      name: data.name,
      email: data.email,
      entries: data.entries,
      joined: data.joined,
      isBlocked: data.isBlocked,
      sentRequests: data.sentRequests,
      receivedRequests : data.receivedRequests
    }})
  }
  setNull = () => {
    this.setState({user:null})
  }
  render(){
    // console.log(this.state);
    return (
      <div className="App">
         <Particles className='particles'
          params={particlesOptions}
        />
        <Navigation setNull={this.setNull} user={this.state.user}/>
        <Switch>
          <Route exact path="/" render={()=>this.state.user!==null ? (<Home user={this.state.user} loadUser={this.loadUser}/>):(<SignIn loadUser={this.loadUser}/>)}/>
          <Route exact path="/admin" render={()=><AdminPage user={this.state.user} />}/>
          {/* <Route exact path="/requests" render={()=>this.state.user!==null ? (<Requests user={this.state.user} loadUser={this.loadUser}/>):(<SignIn loadUser={this.loadUser}/>)}/> */}
          <Route exact path="/signup" render={()=>this.state.user===null?(<SignUp loadUser={this.loadUser}/>):(<Redirect to="/"/>)}/>
          <Route exact path="/redeempoints" render={()=>this.state.user!==null ? (<Redeem user={this.state.user} loadUser={this.loadUser}/>):(<SignIn loadUser={this.loadUser}/>)}/>
        </Switch>
        <AdSense.Google
          client='ca-pub-8175712597372545'
          slot='7806394673'
          style={{ display: 'block' }}
          layout='in-article'
          format='fluid'
        />
        <Footer/>
      </div>
      )
  }
}

export default App;
